'use client'
"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/popover.web.tsx
var popover_web_exports = {};
__export(popover_web_exports, {
  Close: () => Close2,
  Content: () => Content2,
  Overlay: () => Overlay,
  Portal: () => Portal2,
  Root: () => Root2,
  Trigger: () => Trigger2,
  useRootContext: () => useRootContext
});
module.exports = __toCommonJS(popover_web_exports);
var Popover = __toESM(require("@radix-ui/react-popover"));
var import_hooks = require("@rn-primitives/hooks");
var Slot = __toESM(require("@rn-primitives/slot"));
var React = __toESM(require("react"));
var import_react_native = require("react-native");
var RootContext = React.createContext(null);
var Root2 = React.forwardRef(
  ({ asChild, onOpenChange: onOpenChangeProp, ...viewProps }, ref) => {
    const [open, setOpen] = React.useState(false);
    function onOpenChange(value) {
      setOpen(value);
      onOpenChangeProp?.(value);
    }
    const Component = asChild ? Slot.View : import_react_native.View;
    return <RootContext.Provider value={{ open, onOpenChange }}><Popover.Root open={open} onOpenChange={onOpenChange}><Component ref={ref} {...viewProps} /></Popover.Root></RootContext.Provider>;
  }
);
Root2.displayName = "RootWebPopover";
function useRootContext() {
  const context = React.useContext(RootContext);
  if (!context) {
    throw new Error("Popover compound components cannot be rendered outside the Popover component");
  }
  return context;
}
var Trigger2 = React.forwardRef(
  ({ asChild, onPress: onPressProp, role: _role, disabled, ...props }, ref) => {
    const { onOpenChange, open } = useRootContext();
    const augmentedRef = (0, import_hooks.useAugmentedRef)({
      ref,
      methods: {
        open() {
          onOpenChange(true);
        },
        close() {
          onOpenChange(false);
        }
      }
    });
    function onPress(ev) {
      if (onPressProp) {
        onPressProp(ev);
      }
      onOpenChange(!open);
    }
    (0, import_hooks.useIsomorphicLayoutEffect)(() => {
      if (augmentedRef.current) {
        const augRef = augmentedRef.current;
        augRef.dataset.state = open ? "open" : "closed";
        augRef.type = "button";
      }
    }, [open]);
    const Component = asChild ? Slot.Pressable : import_react_native.Pressable;
    return <Popover.Trigger disabled={disabled ?? void 0} asChild><Component
      ref={augmentedRef}
      onPress={onPress}
      role='button'
      disabled={disabled}
      {...props}
    /></Popover.Trigger>;
  }
);
Trigger2.displayName = "TriggerWebPopover";
function Portal2({ forceMount, container, children }) {
  return <Popover.Portal forceMount={forceMount} children={children} container={container} />;
}
var Overlay = React.forwardRef(
  ({ asChild, forceMount, ...props }, ref) => {
    const Component = asChild ? Slot.Pressable : import_react_native.Pressable;
    return <Component ref={ref} {...props} />;
  }
);
Overlay.displayName = "OverlayWebPopover";
var Content2 = React.forwardRef(
  ({
    asChild = false,
    forceMount,
    align = "start",
    side = "bottom",
    sideOffset = 0,
    alignOffset = 0,
    avoidCollisions = true,
    insets: _insets,
    disablePositioningStyle: _disablePositioningStyle,
    onCloseAutoFocus,
    onEscapeKeyDown,
    onInteractOutside,
    onPointerDownOutside,
    onOpenAutoFocus,
    ...props
  }, ref) => {
    const Component = asChild ? Slot.View : import_react_native.View;
    return <Popover.Content
      onCloseAutoFocus={onCloseAutoFocus}
      onEscapeKeyDown={onEscapeKeyDown}
      onInteractOutside={onInteractOutside}
      onPointerDownOutside={onPointerDownOutside}
      forceMount={forceMount}
      align={align}
      side={side}
      sideOffset={sideOffset}
      alignOffset={alignOffset}
      avoidCollisions={avoidCollisions}
      onOpenAutoFocus={onOpenAutoFocus}
    ><Component ref={ref} {...props} /></Popover.Content>;
  }
);
Content2.displayName = "ContentWebPopover";
var Close2 = React.forwardRef(
  ({ asChild, onPress: onPressProp, disabled, ...props }, ref) => {
    const augmentedRef = (0, import_hooks.useAugmentedRef)({ ref });
    const { onOpenChange, open } = useRootContext();
    function onPress(ev) {
      if (onPressProp) {
        onPressProp(ev);
      }
      onOpenChange(!open);
    }
    (0, import_hooks.useIsomorphicLayoutEffect)(() => {
      if (augmentedRef.current) {
        const augRef = augmentedRef.current;
        augRef.type = "button";
      }
    }, []);
    const Component = asChild ? Slot.Pressable : import_react_native.Pressable;
    return <><Popover.Close disabled={disabled ?? void 0} asChild><Component
      ref={augmentedRef}
      onPress={onPress}
      role='button'
      disabled={disabled}
      {...props}
    /></Popover.Close></>;
  }
);
Close2.displayName = "CloseWebPopover";
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Close,
  Content,
  Overlay,
  Portal,
  Root,
  Trigger,
  useRootContext
});
